// extracted by mini-css-extract-plugin
export default {"iconBox":"VbUOpGgjh3lZOBoOzcg_"};